import { createStateSelectorHook } from 'src/lib/sweetState';
import { GenerationToolStore } from 'src/store/generationTool';

export const useGenerationToolSettings = createStateSelectorHook(GenerationToolStore, [
  'newTools',
  'improvedTools',
]);
